import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from '../../../shared/hooks';
import { AutoComplete } from '../../../components';
import * as translations from '../intl';
import { GeneralContext } from '../../../shared/contexts/GeneralContext.context';
import { apiService } from '../../../services';

const LOCALE_MAP = {
  es: 'es-ES',
  pt: 'pt-PT',
  fr: 'fr-FR',
  de: 'de-DE',
};

const SelectAppointment = ({ label, values }) => {
  useTranslation({ translationsFile: translations });
  const { setIsLoading, amosToken } = useContext(GeneralContext);

  const [appointmentsAmos, setAppointmentsAmos] = useState([]);

  useEffect(() => {
    if (!values?.timezone || !values?.language) return;

    const locale = LOCALE_MAP[values.language] ?? 'en-UK';

    (async () => {
      try {
        setIsLoading(true);
        const { data } = await apiService.amos.getAppointments(
          values.language,
          values.timezone,
          amosToken,
          values.countryResidence,
          locale
        );
        setAppointmentsAmos(data);
      } catch (err) {
        console.log(err);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [values?.timezone, values?.language, values?.countryResidence]);

  return (
    <>
      <AutoComplete
        label={label}
        options={appointmentsAmos}
        name="appointment"
      />
    </>
  );
};

export default SelectAppointment;
